import { Component, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'sy-dismiss',
  styleUrl: 'scss/index.scss',
  shadow: true,
})
export class Dismiss {
  /**
   * Sets dismiss button state to disabled.
   */
  @Prop({ reflect: true }) disabled = false;

  /**
   * Sets dismiss size to large.
   */
  @Prop({ reflect: true }) large = false;

  /**
   * Custom aria-label for the dismiss button
   */
  @Prop({ reflect: true }) accessibleLabel: string;

  render() {
    return (
      <Host>
        <sy-button
          accessibleLabel={this.accessibleLabel}
          class="button-dismiss"
          content="icon-only"
          icon="close"
          disabled={this.disabled}
        ></sy-button>
      </Host>
    );
  }
}
